
import Placeholder from '../components/Placeholder';

function OmniboxPlaceholder() {
  const title = 'Omnibox';
  const description = 'This section provides a centralized view of every Omnibox tablet deployed throughout the fleet. It is designed to help technical teams manage hardware, monitor software versions, and maintain accurate records throughout the life of each device.';
  const features = [
    'Automatic detection of installed software versions',
    'Identification of tablets requiring updates',
    'Hardware inventory and deployment records',
    'Tracking of tablet assignments and machine installations',
    'Logging of major lifecycle events, repairs, and replacements',
    'Device health and connectivity monitoring',
    'Centralized access to support resources and documentation',
  ];
  const benefits = 'By maintaining a complete history for each tablet, technical teams can better understand device reliability, streamline support efforts, and make informed decisions regarding repairs, replacements, and future deployments.';

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default OmniboxPlaceholder;